import { useSelector } from "react-redux";
import { Bot } from "lucide-react";
import LogoOpenAI from "../../../../assets/icons/LogoOpenAI";
import LogoClaude from "../../../../assets/icons/LogoClaude";
import Spinner from "../../../../assets/icons/Spinner";
import Message from "../../../../i18n/Message";
import "./ReplyLoadingState.scss";
import { chatSelectors } from "../store/chatReducer";
import MessageTextContainer from "./MessageTextContainer";
import ReplyToolUses from "./tool-request/ReplyToolUses";
import ThinkingBlocks from "./thinking/ThinkingBlocks";
import modelDescriptors, {
  currentModelDescriptions,
} from "../../../../model/model-providers/modelDescriptors";
import ModelVendors from "../../../../model/model-providers/modelVendors";
import NebiusChatAvatar from "./NebiusChatAvatar";
import AgenticTimeline from "./agentic/AgenticTimeline";

const ReplyLoadingState = ({ chat, onApprove, onReject }) => {
  const replyPart = useSelector(chatSelectors.getReplyPart);
  const replyToolUses = useSelector(chatSelectors.getReplyToolUses);
  const replyThinkingBlocks = useSelector(chatSelectors.getReplyThinkingBlocks);
  const replyAgenticTimeline = useSelector(chatSelectors.getReplyAgenticTimeline);
  const replyAgenticSessionStatus = useSelector(chatSelectors.getReplyAgenticSessionStatus);

  // Determine the model vendor
  const model = currentModelDescriptions.find(
    (item) => item.id === chat?.modelId
  );
  const oldModel = modelDescriptors.find((item) => item.id === chat?.modelId);
  const vendor = model?.vendor || oldModel?.vendor;

  // Check if there are any incomplete thinking blocks
  const hasIncompleteThinkingBlocks =
    replyThinkingBlocks &&
    replyThinkingBlocks.some((block) => !block.isComplete);

  // Check if there are any manual (non-auto-executed) tool uses
  const hasManualToolUses =
    replyToolUses &&
    replyToolUses.length > 0 &&
    replyToolUses.some((toolUse) => toolUse.autoExec !== true);

  return (
    <div className={"reply_loading_state "}>
      <div className="avatar">
        {vendor === ModelVendors.OPENAI && (
          <div className="openai_avatar">
            <LogoOpenAI color="#fff" />
          </div>
        )}
        {vendor === ModelVendors.ANTHROPIC && (
          <div className="claude_avatar">
            <LogoClaude color="#fff" size={24} />
          </div>
        )}
        {vendor === ModelVendors.NEBIUS && (
          <NebiusChatAvatar modelId={chat?.modelId} />
        )}
        {!vendor && (
          <div className="bot_avatar">
            <Bot size={24} color="#fff" />
          </div>
        )}
      </div>
      <div className="message_item">
        <div>
          {replyAgenticTimeline && replyAgenticTimeline.length > 0 && (
            <AgenticTimeline
              timeline={replyAgenticTimeline}
              sessionStatus={replyAgenticSessionStatus}
              defaultExpanded={true}
            />
          )}
          {replyThinkingBlocks && replyThinkingBlocks.length > 0 && (
            <ThinkingBlocks blocks={replyThinkingBlocks} />
          )}
          <MessageTextContainer>{replyPart}</MessageTextContainer>
          {replyToolUses && (
            <ReplyToolUses onApprove={onApprove} onReject={onReject} />
          )}
        </div>
        {!hasManualToolUses && !hasIncompleteThinkingBlocks && (
          <div className="reply_spinner">
            <Message id="reply_loading_state" /> <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReplyLoadingState;
